import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import Modal from 'modules/common/components/Modal';

function TaxCreditDetailsModal({ taxCreditData }) {
  return (
    <Modal.Body>
      <div>
        <div className="row">
          <div className="col-12">
            <div className="table-responsive">
              <table className="table table-bordered table-sm table-hover">
                <tbody className="table-details">
                  <tr>
                    <td className="font-weight-bold ">Tax Credit Number</td>
                    <td>{get(taxCreditData, 'attributes.tc_number') || '-'}</td>
                  </tr>
                  <tr>
                    <td className="font-weight-bold ">E-OR Number</td>
                    <td>{get(taxCreditData, 'attributes.e_or_no') || '-'}</td>
                  </tr>
                  <tr>
                    <td className="font-weight-bold ">Date</td>
                    <td>{get(taxCreditData, 'attributes.date_human') || '-'}</td>
                  </tr>
                  <tr>
                    <td className="font-weight-bold ">Application Year</td>
                    <td>{get(taxCreditData, 'attributes.application_year') || '-'}</td>
                  </tr>
                  <tr>
                    <td className="font-weight-bold ">Application Type</td>
                    <td>{get(taxCreditData, 'attributes.application_type') || '-'}</td>
                  </tr>
                  <tr>
                    <td className="font-weight-bold ">Transaction ID</td>
                    <td>{get(taxCreditData, 'attributes.transaction_id') || '-'}</td>
                  </tr>
                  <tr>
                    <td className="font-weight-bold ">Amount</td>
                    <td>{get(taxCreditData, 'attributes.amount_human') || '0.00'}</td>
                  </tr>
                  <tr>
                    <td className="font-weight-bold ">Balance</td>
                    <td>{get(taxCreditData, 'attributes.balance_human') || '0.00'}</td>
                  </tr>
                  <tr>
                    <td className="font-weight-bold ">Notes/Remarks</td>
                    <td>{get(taxCreditData, 'attributes.notes') || '-'}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </Modal.Body>
  );
}

TaxCreditDetailsModal.defaultProps = {
  taxCreditData: {},
};

TaxCreditDetailsModal.propTypes = {
  taxCreditData: PropTypes.instanceOf(Object),
};

export default TaxCreditDetailsModal;
